var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LegalPage',{attrs:{"title":"Disclaimer","subtitle":"Information and risk notice","intro":"The content on gbwhatsdroid.com is published for informational purposes only and does not replace professional, legal, or technical advice.","sections":_vm.sections,"email":"contact@gbwhatsdroid.com","page-name":"disclaimer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }